import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../../services/auth/auth.service';
import { IUser } from 'src/app/shared/interfaces/user/user';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard {

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean {
    const token = this.authService.getAccesToken();
    if (!token) {
      this.router.navigate(['/admin/auth/login']);
      return false;
    }

    const roles = this.authService.getUserRoles();
    if (roles.length > 0) {
      return this.resolveByRoles(roles);
    }

    // Fallback: roles no cacheados (sesión anterior al cambio) → verificar con API
    return this.authService.getUserLoggedData().pipe(
      map((user: any) => {
        const u = user as IUser;
        return this.resolveByRoles(u.roles || []);
      }),
      catchError(() => {
        this.router.navigate(['/admin/auth/login']);
        return of(false);
      })
    );
  }

  private resolveByRoles(roles: string[]): boolean {
    if (roles.includes('super-admin')) return true;
    this.router.navigate(['/admin', 'auth', 'login']);
    return false;
  }
}
